import axios from "axios";

const _axiosMPBXPublic = axios.create();

function MapboxGet<T>(url, q = {}, headers = {}) {
  const apiURL = "https://api.mapbox.com";
  const query = {
    ...q,
    language: "en",
    access_token: process.env.EXPO_PUBLIC_MAP_BOX_SECRET_PUBLIC,
  };
  const config = { headers };
  const search = new URLSearchParams();
  for (let key in query) {
    search.append(key, query[key]);
  }
  const _search = search.toString();
  const _url = `${apiURL}${url}${
    query && Object.keys(query).length ? "?" + _search : ""
  }`;
  return _axiosMPBXPublic.get<T>(_url, config);
}

export { MapboxGet };
